<template>
  <!-- 工单申请 -->
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag
                v-model="queryParam.ticketsEmergency"
                :placeholder="$t('请选择工单紧急程度')"
                dictCode="ticketsEmergency"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择工单类型')">
                <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                <a-select-option :value="11">{{ $t('水厂报修') }}</a-select-option>
                <a-select-option :value="3">{{ $t('报停') }}</a-select-option>
                <a-select-option :value="4">{{ $t('复接') }}</a-select-option>
                <a-select-option :value="7">{{ $t('销户') }}</a-select-option>
                <a-select-option :value="8">{{ $t('用水性质变更') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="toggleSearchStatus">
            <a-form-item :label="$t('创建人员')">
              <a-select v-model="queryParam.createBy" :placeholder="$t('请选择创建人员')">
                <a-select-option value="微信端游客">{{ $t('微信端游客') }}</a-select-option>
                <a-select-option v-for="item in pList" :key="item.username" :value="item.username">{{
                  item.username
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsState" slot-scope="text, record">
          <!-- 换表 -->
          <span v-if="record.ticketsType == 0">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ meterTypeList[text] }}
            </template>
          </span>
          <!-- 工程报装 -->
          <span v-if="record.ticketsType == 1">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ engineeringList[text] }}
            </template>
          </span>

          <!-- 故障报修 -->
          <span v-if="record.ticketsType == 2">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ repairList[text] }}
            </template>
          </span>
          <!-- 报停 -->
          <span v-if="record.ticketsType == 3">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ meterTypeList[text] }}
            </template>
          </span>
          <!-- 复接 -->
          <span v-if="record.ticketsType == 4">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ meterTypeList[text] }}
            </template>
          </span>
        </template>
        <template slot="createBy" slot-scope="text, record">
          <span>{{ text ? text : $t('微信端游客') }}</span>
        </template>
        <span slot="ticketsNum" slot-scope="text, record">
          <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span @click.stop="copySampleNoLink(record.ticketsNum)" class="copySampleNo"><a-icon type="copy" /></span>
        </span>
        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="red" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="yellow" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="blue" v-else-if="text == 3">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>
        <span slot="ticketsContact" slot-scope="text, record">
          {{ text + '/' + record.ticketsContactPhone }}
        </span>
        <!-- 操作按钮 -->
        <span slot="action" slot-scope="text, record">
          <template
            v-if="
              (record.ticketsState == 0 && record.createBy == $store.getters.userInfo.username) ||
              (record.ticketsState == 0 && userRoleCodes != null && userRoleCodes.includes('admin')) ||
              (record.ticketsState == 0 &&
                userRoleCodes &&
                userRoleCodes.includes('wxChuShen') &&
                (record.sourceType == 1 || record.sourceType == 2))
            "
          >
            <!-- 报停 复接 没有编辑 -->
            <a v-if="!(record.ticketsType == 3 || record.ticketsType == 4)" @click="handleEdit(record)">{{ $t('编辑') }}</a>

            <template v-if="record.ticketsType != 1">
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('确定开启吗?')" @confirm="() => handleStart(record)">
                <a>{{ $t('开启') }}</a>
              </a-popconfirm>
            </template>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('删除') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
          <a @click="handleDetail(record)" v-else>{{ $t('详情') }}</a>
          <!-- 换表操作 -->
          <!-- <template v-if="record.ticketsType == 0 && record.ticketsState > 0">
            <a @click="handleOldAudit(record)" v-if="record.ticketsState == 1">旧表审核</a>
            <a @click="handleNewMeter(record)" v-else-if="record.ticketsState == 2">绑定新表</a>
            <a-popconfirm title="确定安装吗?" @confirm="() => handleInstall(record)" v-else-if="record.ticketsState == 3">
              <a>安装</a>
            </a-popconfirm>
            <a @click="handleNewAudit(record)" v-else-if="record.ticketsState == 4">新表审核</a>
            <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 5"/>
          </template> -->
          <!-- 工程报装 -->
          <!-- <template v-else-if="record.ticketsType == 1 && record.ticketsState > 0">
            <a @click="handleFlow(record)">处理</a>
            <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 11" />
          </template> -->
          <!-- <TaskActHistoricDetailBtn :data-id="record.id" v-if="record.ticketsState != 0"></TaskActHistoricDetailBtn>
          <a-divider type="vertical" v-if="record.ticketsState != 0"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>

    <workModal ref="modalForm" @ok="loadData"></workModal>
    <detailModal ref="detailForm" @ok="loadData"></detailModal>
    <auditModal ref="auditForm" @ok="loadData"></auditModal>
    <newMeterModal ref="newMeterForm" @ok="loadData"></newMeterModal>
    <!-- 工程报装 -->
    <Examine ref="ExamineForm" @ok="loadData"></Examine>
    <SurveyInformation ref="SurveyInformationForm" @ok="loadData"></SurveyInformation>
    <Drawing ref="DrawingForm" @ok="loadData"></Drawing>
    <LeaderApproval ref="LeaderApprovalForm" @ok="loadData"></LeaderApproval>
    <FinancialConfirmation ref="FinancialConfirmationForm" @ok="loadData"></FinancialConfirmation>
    <EnterConstruction ref="EnterConstructionForm" @ok="loadData"></EnterConstruction>
    <EngineeringAcceptance ref="EngineeringAcceptanceForm" @ok="loadData"></EngineeringAcceptance>
    <putOnRecord ref="putOnRecordForm" @ok="loadData"></putOnRecord>
    <EngineeringInstallationDetail
      ref="EngineeringInstallationDetailForm"
      @ok="loadData"
    ></EngineeringInstallationDetail>
    <!-- 故障报修 -->
    <RepairDetailModal ref="RepairDetailForm" @ok="loadData" />
    <!-- 详情 -->
    <!-- 报停 复接 ：详情页面 -->
    <TearDownAndInstallDetail ref="tearDownAndInstallDetailForm" @ok="loadData" />
  </a-card>
</template>

<script>
import Vue from 'vue'
import JInput from '@/components/jeecg/JInput'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableDragResize from '@/mixins/TableDragResize'
import { httpAction, getAction, postAction } from '@/api/manage'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import workModal from './modules/workModal'
import detailModal from './modules/detailModal.vue'
import auditModal from './modules/auditModal.vue'
import newMeterModal from './modules/newMeterModal.vue'
import TaskActHistoricDetailBtn from './flowable/TaskActHistoricDetailBtn.vue'
// ------------------------------工程报装--------------------------------------
import Examine from '@/views/engineeringInstallation/constructionManagement/modules/examine/ConstructionDetailModal' // 工程部审核、审核
import SurveyInformation from '@/views/engineeringInstallation/constructionManagement/modules/surveyInformation/ConstructionDetailModal' //录入勘测信息
import Drawing from '@/views/engineeringInstallation/constructionManagement/modules/drawing/ConstructionDetailModal' // 录入图纸和预算
import LeaderApproval from '@/views/engineeringInstallation/constructionManagement/modules/leaderApproval/ConstructionDetailModal' //审批图纸和预算、审批合同
import FinancialConfirmation from '@/views/engineeringInstallation/constructionManagement/modules/financialConfirmation/ConstructionDetailModal' //财务确认
import EnterConstruction from '@/views/engineeringInstallation/constructionManagement/modules/enterConstruction/ConstructionDetailModal' //录入施工文件
import EngineeringAcceptance from '@/views/engineeringInstallation/constructionManagement/modules/engineeringAcceptance/ConstructionDetailModal' //工程验收
import putOnRecord from './modules/putOnRecord' //建档
import EngineeringInstallationDetail from './modules/EngineeringInstallationDetail' //全部流程详情
import RepairDetailModal from './modules/repairDetailModal' //故障报修详情
import TearDownAndInstallDetail from './modules/TearDownAndInstallDetail.vue'
export default {
  name: 'workList',
  mixins: [JeecgListMixin, mixinDevice, TableDragResize],
  components: {
    workModal,
    detailModal,
    auditModal,
    newMeterModal,
    TaskActHistoricDetailBtn,
    Examine,
    SurveyInformation,
    Drawing,
    LeaderApproval,
    FinancialConfirmation,
    EnterConstruction,
    EngineeringAcceptance,
    putOnRecord,
    EngineeringInstallationDetail,
    RepairDetailModal,
    TearDownAndInstallDetail,
    JInput,
  },
  data() {
    return {
      description: '工单管理页面',
      filterDictTextByCache: filterDictTextByCache,
      url: {
        list: '/jeecg-engineering/ticket/tickets/listMy',
        delete: '/jeecg-engineering/ticket/tickets/delete',
        deleteBatch: '/jeecg-engineering/ticket/tickets/deleteBatch',
        exportXlsUrl: '/jeecg-engineering/ticket/tickets/exportXls',
        importExcelUrl: 'jeecg-engineering/ticket/tickets/importExcel',
        start: '/jeecg-engineering/ticket/tickets/startProcess/tickets',
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        userList: '/sys/user/list',
      },
      dictOptions: {},
      superFieldList: [],
      queryParam: {
        workState: 6,
        belongModule: 'tickets',
      },
      pList: [],
      userRoleCodes: [],
    }
  },
  created() {
    this.getSuperFieldList()
    this.getPersonnelList()
    this.userRoleCodes = Vue.ls.get('userRoleCodes')
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('工单编号'),
          align: 'center',
          dataIndex: 'ticketsNum',
          scopedSlots: { customRender: 'ticketsNum' },
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('工单类型'),
          align: 'center',
          dataIndex: 'ticketsType',
          customRender: (text) => {
            return filterDictTextByCache('ticketsType', text)
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('工单紧急程度'),
          align: 'center',
          dataIndex: 'ticketsEmergency',
          // customRender: function (text) {
          //   return filterDictTextByCache('ticketsEmergency', text)
          // },
          scopedSlots: { customRender: 'ticketsEmergency' },
          width: 150,
          ellipsis: true,
        },
        //   {
        //     title: '工单状态',
        //     dataIndex: 'ticketsState',
        //     align:"center",
        //     width: 150,
        //     ellipsis: true,
        //     scopedSlots: { customRender: 'ticketsState' }
        //   },
        {
          title: this.$t('当前节点处理人'),
          align: 'center',
          dataIndex: 'approverName',
          customRender: (t, r, index) => {
            if (t) {
              return t
            } else {
              return '/'
            }
          },
          width: 200,
          ellipsis: true,
        },
        // {
        //   title:'工单截止时间',
        //   align:"center",
        //   dataIndex: 'ticketsDeadline'
        // },
        // {
        //   title:'工单位置',
        //   align:"center",
        //   dataIndex: 'ticketsLocation'
        // },
        // {
        //   title:'工单事务分类',
        //   align:"center",
        //   dataIndex: 'ticketsTransaction'
        // },
        {
          title: this.$t('工单联系人'),
          align: 'center',
          dataIndex: 'ticketsContact',
          scopedSlots: { customRender: 'ticketsContact' },
          width: 200,
          ellipsis: true,
        },
        //   {
        //     title:'联系电话',
        //     align:"center",
        //     dataIndex: 'ticketsContactPhone',
        //     width: 150,
        //     ellipsis: true,
        //   },
        {
          title: this.$t('申请人'),
          align: 'center',
          dataIndex: 'createBy',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'createBy' },
        },
        {
          title: this.$t('申请时间'),
          align: 'center',
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        //   {
        //     title:'更新时间',
        //     align:"center",
        //     dataIndex: 'updateTime',
        //     width: 150,
        //     ellipsis: true,
        //   },
        {
          title: this.$t('来源'),
          align: 'center',
          dataIndex: 'sourceType',
          customRender: (text) => {
            if (text == 1) {
              return this.$t('小程序')
            } else if (text == 2) {
              return this.$t('公众号')
            } else {
              return 'PC'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 180,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    // 工单状态选项值映射
    meterTypeList() {
      return [this.$t('新建工单'), this.$t('现场处理'), this.$t('审核'), this.$t('归档')]
    },
    engineeringList() {
      return [
        this.$t('未开启'),
        this.$t('报装申请'),
        this.$t('报装受理'),
        this.$t('报装勘察设计'),
        this.$t('报装预算'),
        this.$t('报装审批'),
        this.$t('报装收费'),
        this.$t('报装施工'),
        this.$t('报装验收'),
        this.$t('报装建档'),
      ]
    },
    repairList() {
      return [this.$t('新建工单'), this.$t('现场处理'), this.$t('审核'), this.$t('归档')]
    },
  },
  methods: {
    getPersonnelList() {
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.pList = res.result.records
        }
      })
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'ticketsType', text: '工单类型,0:换表' })
      fieldList.push({ type: 'string', value: 'ticketsForeignId', text: '工单外键id' })
      fieldList.push({ type: 'string', value: 'ticketsProcessKey', text: '工单流程key' })
      fieldList.push({ type: 'string', value: 'ticketsNum', text: '工单编号' })
      fieldList.push({ type: 'string', value: 'ticketsLocation', text: '工单位置' })
      fieldList.push({ type: 'string', value: 'ticketsContact', text: '工单联系人' })
      fieldList.push({ type: 'string', value: 'ticketsContactPhone', text: '联系电话' })
      fieldList.push({ type: 'int', value: 'ticketsEmergency', text: '工单紧急程度' })
      fieldList.push({ type: 'int', value: 'ticketsTransaction', text: '工单事务分类' })
      fieldList.push({ type: 'date', value: 'ticketsDeadline', text: '工单截至时间' })
      fieldList.push({ type: 'string', value: 'remark', text: '备注信息' })
      this.superFieldList = fieldList
    },
    searchReset() {
      this.queryParam = {
        workState: 6,
        belongModule: 'tickets',
      }
      this.loadData()
    },
    handleEdit(row) {
      this.$nextTick(() => {
        this.$refs.modalForm.edit(row, 'edit')
      })
    },
    // 详情
    handleDetail(row) {
      this.$nextTick(() => {
        if (row.ticketsType == 0) {
          // 换表详情
          this.$refs.detailForm.init(row)
        } else if (row.ticketsType == 1) {
          this.$refs.EngineeringInstallationDetailForm.init(row, true)
        } else if (row.ticketsType == 2 || row.ticketsType == 11) {
          // 报修详情
          this.$refs.RepairDetailForm.init(row, this.$t('详情'))
        } else if (row.ticketsType == 3 || row.ticketsType == 4) {
          // 复接 报停
          this.$refs.tearDownAndInstallDetailForm.init(row, this.$t('详情'))
        }
      })
    },
    // 开启
    handleStart(row) {
      this.loading = true
      postAction(this.url.start, { dataId: row.id, flowableKey: row.ticketsProcessKey }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('开启成功'))
          this.loading = false
          this.loadData()
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 审核旧表
    handleOldAudit(row) {
      this.$nextTick(() => {
        this.$refs.auditForm.init(row)
      })
    },
    // 绑定新表
    handleNewMeter(row) {
      this.$nextTick(() => {
        this.$refs.newMeterForm.init(row)
      })
    },
    // 安装
    handleInstall(row) {
      let params = {
        dataId: row.id,
        values: {
          dataId: row.id,
        },
        comment: '',
      }
      postAction(this.url.pass, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('安装成功'))
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 审核新表
    handleNewAudit(row) {
      this.$nextTick(() => {
        this.$refs.auditForm.init(row)
      })
    },
    // 工程报装-处理
    handleFlow(row) {
      this.$nextTick(() => {
        if (row.ticketsState == 2) {
          //受理
          this.$refs.ExamineForm.edit(row, true)
        } else if (row.ticketsState == 3) {
          //勘察设计
          this.$refs.SurveyInformationForm.edit(row, true)
        } else if (row.ticketsState == 4) {
          //预算
          this.$refs.DrawingForm.edit(row, true)
        } else if (row.ticketsState == 5) {
          //审批
          this.$refs.LeaderApprovalForm.edit(row, true)
        } else if (row.ticketsState == 6) {
          //收费
          this.$refs.FinancialConfirmationForm.edit(row, true)
        } else if (row.ticketsState == 7) {
          // 施工
          this.$refs.EnterConstructionForm.edit(row, true)
        } else if (row.ticketsState == 8) {
          //验收
          this.$refs.EngineeringAcceptanceForm.edit(row, true)
        } else if (row.ticketsState == 9) {
          //建档
          this.$refs.putOnRecordForm.init(row, true)
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
